import { render, staticRenderFns } from "./RoundButton.vue?vue&type=template&id=bce2eca0&scoped=true&"
import script from "./RoundButton.vue?vue&type=script&lang=js&"
export * from "./RoundButton.vue?vue&type=script&lang=js&"
import style0 from "./RoundButton.vue?vue&type=style&index=0&id=bce2eca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce2eca0",
  null
  
)

export default component.exports